import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import routes from '@/router/routes/index.js'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/' : '/',
  routes
})

path: 

router.beforeEach((to, from, next) => {
  console.log('route - 0')
  console.log(process.env.NODE_ENV)
  

  //const authenticated = localStorage.getItem("auth")

  const authenticated = store.state.global.user.loggedIn
  //console.log('dentro beforeEach',authenticated)
  const onlyLoggedOut = to.matched.some(record => record.meta.onlyLoggedOut)
  const isPublic = to.matched.some(record => record.meta.public)
  const isAdminSagrilaft = to.matched.some(record => record.meta.adminSagrilaft)
  const isAdminCumplimiento = to.matched.some(record => record.meta.adminCumplimiento)
  const isTercero = to.matched.some(record => record.meta.tercero)
  const isAdmin = to.matched.some(record => record.meta.admin)

  console.log('authenticated: '+authenticated)
  console.log('onlyLoggedOut: '+onlyLoggedOut)
  console.log('isPublic: '+isPublic)
  console.log('isAdmin: '+isAdmin)
  console.log('isAdminSagrilaft: '+isAdminSagrilaft)
  console.log('isAdminCumplimiento: '+isAdminCumplimiento)
  console.log('isTercero: '+isTercero)


  if (isPublic && !authenticated) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    console.log('route - 1')
    console.log(localStorage.getItem("auth"))
    
    if(to.path == '/login' || to.path == '/ForgotPassword' || to.path == '/ResetPassword'){
       next()
    }else{
       next('/login')
    }
  }else if (!isPublic && !authenticated) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    console.log('route - 1')
    console.log(localStorage.getItem("auth"))
    
    if(to.path == '/login' || to.path == '/ForgotPassword' || to.path == '/ResetPassword'){
       next()
    }else{
       next('/login')
    } 
  }else  if (authenticated && isTercero) {
    console.log("ok log")
    console.log(store.state.global.user)
    console.log('route - 2')
    if(store.state.global.user.perfil == 2){

      if(store.state.global.user.estadoregistro == 0 || store.state.global.user.estadoregistro == 4 || store.state.global.user.estadoregistro == 5){
         
         if(store.state.global.user.tiporegistro == '1'){
            if(to.path == '/registro'){
               next()
            }else{
               next('/registro')
            }
         }else if(store.state.global.user.tiporegistro == '2'){
            if(to.path == '/registroexterior'){
               next()
            }else{
               next('/registroexterior')
            }
         }else{
            if(to.path == '/listresgistros'){
               next()
            }else{
               next('/listresgistros')
            }
         }
         
        
      }else{
         console.log('firma')
         console.log(store.state.global.user.estadoregistro)
         console.log(store.state.global.user.metodofirma)
         
         if(store.state.global.user.estadoregistro == 11 && store.state.global.user.metodofirma == "2"){
            console.log('manuscrita')
            if(to.path == '/registrofirmamanuscrita'){
               next()
            }else{
               next('/registrofirmamanuscrita')
            }
         }else{
            console.log('oki')
            if(store.state.global.user.tiporegistro == '1'){
               console.log('oki-1')
               console.log('visual')
               if(to.path == '/registrovisual'){
                  next()
               }else{
                  next('/registrovisual')
               }
            }else if(store.state.global.user.tiporegistro == '2'){
               console.log('oki-2')
               console.log('exterior')
               if(to.path == '/registroexteriorvisual'){
                  next()
               }else{
                  next('/registroexteriorvisual')
               }
            }else{
               console.log('oki-3')
               console.log(to.path)
               if(to.path == '/listregistros'){
                  next()
               }else{
                  next('/listregistros')
               }
            }
            
         }

         

      }

      
    }
    
  }else if(authenticated && (isAdminSagrilaft || isAdminCumplimiento || isAdmin)){
        
        
    if(!isAdminSagrilaft && (store.state.global.user.perfil == 4 || store.state.global.user.perfil == 5)){
      console.log('store.state.global.user.multipleregistro',store.state.global.user.multipleregistro)
      if(store.state.global.user.multipleregistro){
         next('/listusuariosempresas') 
      }else{
         next('/dashboardempresa') 
      }
      
    }
    
    if(!isAdminCumplimiento && store.state.global.user.perfil == 3){
      
      next('/dashboardcumplimiento') 
    }

    next()
        

  }
  
  
})


  export default router;